import { render, staticRenderFns } from "./ArrangeList.vue?vue&type=template&id=3a874612&"
import script from "./ArrangeList.vue?vue&type=script&lang=js&"
export * from "./ArrangeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports